import { Form, Formik } from "formik";
import React, { useState } from "react";
import Input from "../common/form/Input";
import Button from "../common/Button";
import { CompleteRegistrationSchema } from "../../utils/validation";
import toast from "react-hot-toast";
import { confirmSignIn } from "aws-amplify/auth";

const CompleteRegistration = ({ user, getAuthenticatedUser }) => {
  const [isLoading, setLoading] = useState(false);
  return (
    <div className="flex min-h-screen flex-1 flex-col justify-center px-6 py-12 lg:px-8 dark:bg-gray-900 dark:text-white">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <div className="mx-auto lg:w-52">
          <img src="/PC_Horz_Color.svg" alt="logo" />
        </div>
        <h2 className="-mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-white">
          Complete Registration
        </h2>
      </div>
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <Formik
          initialValues={{ password: "" }}
          validationSchema={CompleteRegistrationSchema}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              const { isSignedIn } = await confirmSignIn({
                challengeResponse: values.password,
              });
              if (isSignedIn) {
                await getAuthenticatedUser(() =>
                  toast.success("You have successfully logged in.")
                );
              }
            } catch (e) {
              toast.error(e.message);
            } finally {
              setLoading(false);
            }
          }}
        >
          <Form className="space-y-6">
            <Input
              required
              name="password"
              label="New Password"
              type="password"
            />
            <Input
              required
              name="confirm"
              label="Confirm New Password"
              type="password"
            />
            <Input name="name" label="Full name" />
            <Button type="submit" disabled={isLoading} loading={isLoading}>
              Complete
            </Button>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default CompleteRegistration;
